import { motion } from 'framer-motion';

const ServicesHero = () => {
  return (
    <section className="pt-32 pb-20 bg-primary-yellow">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h1 className="text-5xl lg:text-7xl font-extrabold text-black mb-6">
            Nuestros Servicios
          </h1>
          <p className="text-xl text-gray-dark max-w-3xl mx-auto leading-relaxed">
            Soluciones legales completas para emprendedores, pymes y empresas en Chile. Procesos estructurados y herramientas tecnológicas combinadas con revisión profesional de abogados.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesHero;